module.exports = "/images/vendor/jquery-ui-dist/ui-icons_ffffff_256x240.png?ea4ebe072be75fbbea002631916836de";